import {
  FullScreenGalleryNextButton,
  FullScreenGalleryContainerSt,
  FullScreenGalleryInnerContainerSt,
  FullScreenGalleryPreviousButton,
} from './FullScreenGallery.css';
import MediaGallerySlide from 'app/shared/components/MediaGallery/components/MediaSlider/components/FullScreenSlides/components/FullScreenGallery/components/MediaGallerySlide/MediaGallerySlide';
import { usePlayMedia } from 'app/providers/PlayVideoProvider';
import { ChevronLeft, ChevronRight } from '@heycar-uikit/icons';

const FullScreenGallery = ({
  items,
  handleBackClick,
  handleNextClick,
  offset,
  handleMediaGalleryClick,
}) => {
  const { fullScreenAndPlay } = usePlayMedia();

  return (
    <FullScreenGalleryContainerSt>
      {!fullScreenAndPlay && (
        <FullScreenGalleryPreviousButton onClick={handleBackClick}>
          <ChevronLeft />
        </FullScreenGalleryPreviousButton>
      )}
      <FullScreenGalleryInnerContainerSt>
        {items.map((props, index) => (
          <MediaGallerySlide
            {...props}
            key={index}
            offset={offset}
            index={index}
            handleMediaGalleryClick={handleMediaGalleryClick}
          />
        ))}
      </FullScreenGalleryInnerContainerSt>
      {!fullScreenAndPlay && (
        <FullScreenGalleryNextButton onClick={handleNextClick}>
          <ChevronRight />
        </FullScreenGalleryNextButton>
      )}
    </FullScreenGalleryContainerSt>
  );
};

export default FullScreenGallery;
